<img *ngIf="shouldTrackPixel"
     height="1"
     width="1"
     [src]="pixelImageUrl" />
